import React from 'react';

export default function AddKeyToItem<TItem>(
  renderItem: (item: TItem, index: number) => JSX.Element,
  keyExtractor: (item: TItem, index: number) => string
) {
  return (item: TItem, index: number) => {
    return (
      <React.Fragment key={keyExtractor(item, index)}>
        {renderItem(item, index)}
      </React.Fragment>
    );
  };
}
